import { jsPDF } from 'jspdf';
import { addCanvasToSinglePagePdf, captureVoucherElement } from '../shared/voucherPdfUtils';

export const exportConfirmationVoucherPdfFromElement = async (element, header) => {
    if (!element || !header) return;

    const canvas = await captureVoucherElement(element);

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    addCanvasToSinglePagePdf(pdf, canvas, imgData);

    pdf.save(`Confirmation_Voucher_${header.ConfirmationId || 'voucher'}.pdf`);
};
